import { render, staticRenderFns } from "./take-photos-normal.vue?vue&type=template&id=00bc4d18&scoped=true&"
import script from "./take-photos-normal.vue?vue&type=script&lang=ts&"
export * from "./take-photos-normal.vue?vue&type=script&lang=ts&"
import style0 from "./take-photos-normal.vue?vue&type=style&index=0&id=00bc4d18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bc4d18",
  null
  
)

export default component.exports